import styled, { css, keyframes } from 'styled-components';
import { Container, Slider } from '@swordhealth/ui-corporate';

// Card content animation
const slideInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOutDown = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100px);
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;

  > p {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    gap: 40px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    gap: 32px;
  }
`;

export const StyledContainer = styled(Container)`
  row-gap: 32px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    row-gap: 24px;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  justify-content: center;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 32px 32px 32px;
  border-radius: ${(props) => props.theme.borderRadius.default.lg};
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(247, 244, 242, 0.4) 0%,
    var(--Default-Neutral-200, #f7f4f2) 60%
  );
  max-width: 276px;
  min-width: 272px;
  height: 380px;
  overflow: hidden;

  h2 {
    width: 100%;
    font-size: 24px;
    letter-spacing: -0.056rem;
    line-height: 29px;
  }

  p {
    font-size: ${(props) => props.theme.font.body.size.md};
    font-weight: ${(props) => props.theme.font.weight.body.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.md};
  }

  p strong,
  b {
    font-weight: ${(props) => props.theme.font.weight.body.regular};
    color: ${(props) => props.theme.colors.primary.default} !important;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 18px;
  right: 17.4px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.primary.default};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  z-index: 1000001;
  cursor: pointer;

  svg > path {
    fill: ${(props) => props.theme.colors.primary.default};
  }
`;

export const CardInner = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
`;

export const CardHoverContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.neutral[200]};
  border-radius: ${(props) => props.theme.borderRadius.default.lg};
  opacity: 0;
  pointer-events: none;
  padding: 32px;
  animation: ${slideOutDown} 300ms ease-out;

  ${(props) =>
    props.$isHovered &&
    css`
      opacity: 1;
      pointer-events: auto;
      animation: ${slideInUp} 300ms ease-out;
    `}

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding: 72px 32px 32px;
  }
`;

export const CardHoverInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 16px;
  opacity: 1;
  pointer-events: none;

  ${(props) =>
    props.$isHovered &&
    css`
      pointer-events: auto;
    `}

  > a {
    width: 100%;
    font-size: 13px;
    padding: 12px 17px;
    margin-top: auto;
  }
`;

export const ImageWrapper = styled.div`
  align-self: center;
  padding-bottom: 44px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    padding-top: 8px;
  }
`;

export const SliderWrapper = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow: visible;
`;

export const StyledSlider = styled(Slider)`
  width: 100%;
  max-width: 100vw;
  overflow: visible;
  pointer-events: auto;

  & .swiper {
    width: 100%;
    max-width: 100vw;
    padding-bottom: 16px;
    overflow: visible;
  }

  & .swiper-wrapper {
    width: 100vw !important;
    display: flex;
    align-items: center;
  }

  & .swiper-slide {
    width: 276px !important;
    display: flex;
    justify-content: center;
  }

  & .swiper-pagination-bullet {
    --button-color: ${(props) => props.theme.colors.white} !important;
    opacity: 1;
  }

  & .swiper-pagination-bullet-active {
    --button-color: ${(props) => props.theme.colors.grey[800]} !important;
  }
`;
